const accountOptions = (customer) => {
  return customer.companies.map(x => ({key: x.id, text: x.name, value: x.id})).sort((a, b) => {
    if (a.text.toUpperCase() > b.text.toUpperCase()) return 1
    if (b.text.toUpperCase() > a.text.toUpperCase()) return -1
    return 0
  })
}

export {accountOptions}
